import { useFilterInvoiceContext } from "./filter-invoice.context";

export function FilterInvoice() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterInvoiceContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}